/** Textos de ajuda (tooltip no título) por tela. Só onde a tela tem regra que ela mesma não mostra. */
export const PAGE_HELP = {
  leads:
    'Liste clientes fidelizados da loja. Busque por nome, CPF ou e-mail. Clique no card para abrir o detalhe; use o checkbox para selecionar vários (reenvio em lote). O ícone de olho também abre o detalhe. Exportar envia a base por e-mail.',
  banners:
    'Imagens promocionais exibidas no app do cliente. Adicione banners pelo assistente, visualize a arte, ative ou desative e reordene com as setas. Selecione vários para ativar ou desativar em lote.',
  products:
    'Produtos do catálogo que não entram como resgate no app. O tipo gravado segue o redeemType do passbook.',
  redemptions:
    'Benefícios que o cliente resgata no app. O tipo gravado segue o redeemType do passbook.',
  metabaseConfig:
    'Dashboards do Metabase exibidos no Painel/BI da loja. Cada item vira uma aba quando há mais de um. "Dashboard" é o ID numérico do dashboard no Metabase; "Loja individual" e "Aba" são opcionais.',
} as const;
